import type Product from '~/models/Product/Product'
export default async (products: Product[]) => {
    performance.mark('startRefreshFrequentlyActualizedData')

    const config = useRuntimeConfig()
    const nuxtApp = useNuxtApp()
    if (!(process.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered)) {
        return
    }
    if (!config.public.refreshFrequentlyActualizedData) {
        return
    }

    const productIds: number[] = []
    products.forEach((product: Product) => {
        productIds.push(product.id)
    })
    const productFrequentlyActualizedDataCollection = await useNuxtApp().$repository.getProductFrequentlyActualizedData(
        productIds,
        useUidCookie().value
    )
    products.forEach((product: Product) => {
        const data = productFrequentlyActualizedDataCollection[product.id] || null
        if (data) {
            product.availabilityText = data.availabilityText
            product.price = data.price
            product.hasSuperPrice = data.hasSuperPrice
            product.priceBeforeDiscount = data.priceBeforeDiscount
            product.lowestPrice = data.lowestPrice
            product.priceNoVat = data.priceNoVat
            product.originalPriceNoVat = data.originalPriceNoVat
            product.hasCompetitorSuperPrice = data.hasCompetitorSuperPrice
            product.attributes.maxAmountPerOrder = data.maxAmountPerOrder
            product.amountInStock = data.amountInStock
        }
    })
    performance.mark('endRefreshFrequentlyActualizedData')
    performance.measure('refreshFrequentlyActualizedData', 'startRefreshFrequentlyActualizedData', 'endRefreshFrequentlyActualizedData')
}
